interface OrganizationOverviewSkeletonProps {
    title: string;
}

export function OrganizationOverviewSkeleton({
    title,
}: OrganizationOverviewSkeletonProps) {
    return (
        <div className="flex flex-col gap-4">
            <h3 className="text-sm font-medium text-white-100">{title}</h3>
            <div
                className="grid gap-3"
                style={{
                    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                }}
            >
                {Array.from({ length: 4 }, (_, i) => (
                    <div
                        key={i}
                        className="skeleton-item-container border border-grey-600 rounded-[10px] p-4 flex flex-col gap-3"
                    >
                        <div className="flex items-center gap-1 h-5">
                            <div className="size-[14px] skeleton-item rounded" />
                            <div className="h-[14px] w-20 skeleton-item rounded" />
                        </div>
                        <div className="h-7 w-16 skeleton-item rounded" />
                        <div className="h-4 w-28 skeleton-item rounded" />
                    </div>
                ))}
            </div>
        </div>
    );
}
